<template>
  <div class="home-hero">
    <div class="home-card">
      <div class="home-logo">
        <img src="../assets/aslogo.png" alt="logo">
      </div>
      <h1 class="home-title">AIRSUSPENSION ADMINISTRATOR</h1>
      <p class="home-subtitle">Inventory · Orders · Invoicing</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style>
.home-hero {
  min-height: calc(100vh - 140px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}

.home-card {
  text-align: center;
  padding: 3rem clamp(1.5rem, 6vw, 5rem);
  background: radial-gradient(120% 140% at 50% 0%, var(--surface-2) 0%, var(--surface) 55%);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  max-width: 640px;
  width: 100%;
}

.home-logo {
  display: inline-flex;
  padding: 1.5rem;
  border-radius: 24px;
  background-color: var(--surface-3);
  border: 1px solid var(--border-strong);
  margin-bottom: 2rem;
}

.home-logo img {
  width: clamp(140px, 30vw, 220px);
  height: auto;
}

.home-title {
  font-size: clamp(1.25rem, 3vw, 1.75rem);
  font-weight: 800;
  letter-spacing: 0.06em;
  margin-bottom: 0.5rem;
}

.home-subtitle {
  color: var(--text-muted);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-size: 0.8125rem;
  margin: 0;
}
</style>
